const GOOGLE_ANALYTICS_FOUR_ID = process.env.GOOGLE_ANALYTICS_FOUR_ID ?? '';

/** ----------------------------------------------------------------------------------
The script below is required to connect with GA4.(2022/10/12 just now)

<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=<GA4 Measurement ID>"></script>
↑ This is automatically inserted by Google Tag Maneger.

<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', '<GA4 Measurement ID>');
</script>
↑ Insert only this script in the initialization on prod.

-------------------------------------------------------------------------------------- */
const initializeGA4 = () => {
  // @ts-expect-error window object extended
  if (!window.GA4_INITIALIZED) {
    // eslint-disable-next-line no-console
    console.log('GA4 init');
    if (GOOGLE_ANALYTICS_FOUR_ID === process.env.GOOGLE_ANALYTICS_FOUR_ID_DEV) {
      const script1 = document.createElement('script');
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_FOUR_ID}`;
      script1.async = true;
      document.body.appendChild(script1);
    }
    const script2 = document.createElement('script');
    script2.text = `window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', '${GOOGLE_ANALYTICS_FOUR_ID}');
	`;
    document.body.appendChild(script2);

    // @ts-expect-error window object extended
    window.GA4_INITIALIZED = true;
  }
};

export const trackingEventForGA4 = (action = '', category = '', label = '') => {
  if (!action || !category) return;
  if (!GOOGLE_ANALYTICS_FOUR_ID) return;
  initializeGA4();
  // eslint-disable-next-line no-console
  console.log(
    `Logging event for category ${category} and action ${action}${
      label ? ` with label ${label}. it send to GA4` : ''
    }`
  );

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  gtag('event', action, {
    ua_event_action: action,
    ua_event_category: category,
    ua_event_label: label,
  });
};
